import { MathBase } from "@goodgamestudios/core";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { Poker2AvatarEvent } from "../../event/Poker2AvatarEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import Event = createjs.Event;

export class Poker2BackgroundScreen extends Poker2Screen {
    public static NAME: string = "Poker2BackgroundScreen";

    constructor(disp: DisplayObject) {
        super(disp);
    }

    public show(): void {
        let wasVisible = this.disp.visible;
        super.show();
        this.updateBackgroundByInventroy();
        if(!wasVisible) {
            Poker2LayoutManager.getInstance().renderBGStage(); // force redraw if disp was invisible, incase `updateBackgroundByInventroy` skipped redraw
        }
        this.controller.addEventListener("avatarChanged", this.bindFunction(this.onChangeBackground));
        this.controller.addEventListener("avatarReset", this.bindFunction(this.onChangeBackground));
        this.controller.addEventListener("changeInventar", this.bindFunction(this.onChangeBackground));
        this.controller.addEventListener("avatarClothesChanged", this.bindFunction(this.onChangeTemp));

        // prevent strange mouse-over lagging within browsers
        ((this.disp) as Container).mouseChildren = false;
    }

    public hide(): void {
        super.hide();
        this.controller.removeEventListener("avatarChanged", this.bindFunction(this.onChangeBackground));
        this.controller.removeEventListener("avatarReset", this.bindFunction(this.onChangeBackground));
        this.controller.removeEventListener("changeInventar", this.bindFunction(this.onChangeBackground));

        this.controller.removeEventListener("avatarClothesChanged", this.bindFunction(this.onChangeTemp));
    }

    private onChangeTemp(event: Poker2AvatarEvent): void {
        this.updateBackgroundByInventroy(event.params[0] as AvatarVO);
    }

    private onChangeBackground(event: Event): void {
        this.updateBackgroundByInventroy();
    }

    private updateBackgroundByInventroy(avatarVO: AvatarVO = null): void {
        var newBackground: Container;
        var inventoryItem: ItemsVO;
        if (avatarVO) {
            inventoryItem = Poker2Model.avatarData.getItemByCategory("screens", avatarVO);
        } else {
            inventoryItem = Poker2Model.avatarData.getItemByCategory("screens", Poker2Model.avatarData.myAvatar);
        }
        let disp = this.disp as Container;
        if (inventoryItem){
            // if the current bg class is the same as the selected inventory item, we skip
            if(disp.children.length === 1) {
                let bgContainer = disp.children[0];
                if(bgContainer instanceof Container && bgContainer.children.length === 1) {
                    let inventoryBG: any = bgContainer.children[0];
                    if(inventoryBG.__proto__.constructor.__fname === inventoryItem.getVisClassName()) {
                        return;
                    }
                }
            }
            newBackground = AvatarHelper.drawItem(inventoryItem);
        } else if(disp.children.length === 1 && disp.children[0] instanceof Library.PokerBackground.PokerBackground){
            // if there's no inventory item selected, the the current bg is already the default one, we skip
            return;
        } else {
            newBackground = new Library.PokerBackground.PokerBackground();
        }

        while ((this.disp as Container).numChildren > 0)
            (this.disp as Container).removeChildAt(0);
        (this.disp as Container).addChild(newBackground);
        Poker2LayoutManager.getInstance().renderBGStage();
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = MathBase.max((this.disp.stage.stageHeight / 600), (this.disp.stage.stageWidth / 800));
            //disp.scaleX = disp.scaleY = layoutManager.scaleFactor;
        }
    }
}
import { AvatarHelper } from "../helper/AvatarHelper";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
